import PropTypes from 'prop-types';
import React from 'react';
import Highlighter from 'react-highlight-words';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import Tooltip from '../../../components/molecules/Tooltip';
import { SECTION_ACCESS_TYPES } from '../../../utils/consts';
import { isScreenViewOnly } from '../../sections';
import { translationPrefix } from '../../utils';
import AccessTypeIcon from '../AccessTypeIcon';
import css from './ScreenItem.css';

const ScreenItem = ({ screen, sectionPermissions, search }) => (
    <div className={css.screenItem}>
        <div className={css.screenName}>
            <Icon
                name="check"
                size={IconSizes.X_SMALL}
                variant={IconVariants.LIGHT}
                interactive={false}
                className={css.checkIcon}
            />
            <span>
                <Highlighter searchWords={[search]} textToHighlight={screen.displayName} autoEscape />
            </span>
        </div>
        {isScreenViewOnly(screen.name, sectionPermissions) && (
            <Tooltip titleTranslationKey="STATIC.PAGES.TEAM_MEMBERS.MANAGE_PERMISSIONS_PAGE.VIEW_ONLY_TOOLTIP">
                <div className={css.viewOnlyBadge}>
                    <AccessTypeIcon
                        accessType={SECTION_ACCESS_TYPES.VIEW}
                        size={IconSizes.X_SMALL}
                        interactive={false}
                        className={css.viewOnlyIcon}
                        withTooltip={false}
                    />
                    <Translate
                        id={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.SECTION_ACCESS_TYPES_TITLE.${SECTION_ACCESS_TYPES.VIEW}`}
                    />
                </div>
            </Tooltip>
        )}
    </div>
);

ScreenItem.propTypes = {
    search: PropTypes.string,
    screen: PropTypes.shape({
        name: PropTypes.string,
        displayName: PropTypes.string,
    }).isRequired,
    sectionPermissions: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })).isRequired,
};

export default ScreenItem;
